import { NoSsr } from '@bygghemmait/components';
import { MediaQueryProvider } from '@bygghemmait/theme/mediaQuery';
import { matcher, Router } from '@bygghemmait/router';
import { HeaderState } from 'models/HeaderState';
import React, { ComponentProps, PropsWithChildren } from 'react';
import { DehydratedState, Hydrate, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider as ReduxProvider } from 'react-redux';
import { Store } from 'redux';
import { DefaultTheme, ThemeProvider } from 'styled-components';

export type ProviderProps<TStore extends HeaderState = HeaderState> = {
  client: QueryClient;
  state: DehydratedState;
  store: Store<TStore>;
  theme: DefaultTheme;
};

export function GecpProviders(
  props: PropsWithChildren<Pick<ComponentProps<typeof Router>, 'hook'>>
): JSX.Element {
  return (
    <MediaQueryProvider>
      <Router matcher={matcher} hook={props.hook}>
        {props.children}
      </Router>
    </MediaQueryProvider>
  );
}

export function Provider<TStore extends HeaderState = HeaderState>(
  props: PropsWithChildren<ProviderProps<TStore>>
) {
  return (
    <ThemeProvider theme={props.theme}>
      <QueryClientProvider client={props.client}>
        <Hydrate state={props.state}>
          <ReduxProvider store={props.store}>
            {props.children}
          </ReduxProvider>
        </Hydrate>
        <NoSsr defer>
          <ReactQueryDevtools initialIsOpen={false} />
        </NoSsr>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
